import axios from 'axios';

const loadAbort = () => {
  return new AbortController();
};

export const getDashboardMetricsEndpoint = (
  token: string,
  role: string = 'proper',
) => {
  let path: string;
  if (role === 'proper') path = `/ts/v1/admin/proper/dashboard`;
  else path = `/ts/v1/admin/dashboard`;
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}${path}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export interface DashboardMetricsFilters {
  onlyAssigned?: boolean;
  startDate?: string;
  endDate?: string;
  status?: string;
  sdrId?: string;
}

export const getDashboardMetricsV2Endpoint = (
  token: string,
  role: string = 'proper',
  marketplace_type?: 'on_rent' | 'on_sale',
  filters?: DashboardMetricsFilters,
) => {
  let path: string;
  if (role === 'proper') path = `/ts/v2/admin/proper/dashboard`;
  else path = `/ts/v2/admin/dashboard`;
  const queryParts: string[] = [];
  if (marketplace_type) queryParts.push(`marketplace_type=${marketplace_type}`);
  if (filters?.onlyAssigned) queryParts.push(`only_assigned=true`);
  if (filters?.startDate) queryParts.push(`start_date=${filters.startDate}`);
  if (filters?.endDate) queryParts.push(`end_date=${filters.endDate}`);
  if (filters?.status) queryParts.push(`status=${filters.status}`);
  if (filters?.sdrId) queryParts.push(`sdr_id=${filters.sdrId}`);
  if (queryParts.length) path += `?${queryParts.join('&')}`;
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}${path}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardMetricsPreSaleEndpoint = (
  token: string,
  role: string = 'proper',
  filters?: DashboardMetricsFilters,
) => {
  let path: string;
  if (role === 'proper') path = `/pre-sales/v1/admin/proper/dashboard`;
  else path = `/pre-sales/v1/admin/dashboard`;
  const queryParts: string[] = [];
  if (filters?.onlyAssigned) queryParts.push(`only_assigned=true`);
  if (filters?.startDate) queryParts.push(`start_date=${filters.startDate}`);
  if (filters?.endDate) queryParts.push(`end_date=${filters.endDate}`);
  if (filters?.status) queryParts.push(`status=${filters.status}`);
  if (filters?.sdrId) queryParts.push(`sdr_id=${filters.sdrId}`);
  if (queryParts.length) path += `?${queryParts.join('&')}`;
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}${path}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardVisitsProperEndpoint = (
  queryParams: string = '',
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/dashboard/visits-by-proper${queryParams}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardPreSaleVisitsProperEndpoint = (
  queryParams: string = '',
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/visits/visits-by-proper${queryParams}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardVisitsEndpoint = (
  queryParams: string = '',
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/proper/visits${queryParams}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardOffersEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/proper/offers?take=50`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const updateVisitStateEndpoint = (
  visitId: string,
  visitState: boolean,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/ts/v1/admin/proper/visits/${visitId}`,
        data: JSON.stringify({
          toggle_on: visitState,
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardResumeVisitsByProperEndpoint = (token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/dashboard/resume-visits`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getDashboardPreSaleVisitsEndpoint = (
  queryParams: string = '',
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/proper/visits${queryParams}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

//pre-sale

export const markAsDoneVisitPreSaleEndpoint = (
  visitId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/proper/visits/${visitId}/mark-as-done`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const reassignSdrVisitPreSaleEndpoint = (
  visitId: string,
  sdrId: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/visits/${visitId}/reassign-sdr`,
        data: JSON.stringify({ sdr_id: sdrId }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export interface PreSaleVisitFeedbackBody {
  project_model_id: string;
  purchase_intent: string;
  objections: string[];
  compared_with?: string;
  prospect_stage: string;
}

export interface RentVisitFeedbackBody {
  interest_level: string;
  objections: string[];
  property_condition: string[];
  owner_recommendation: string;
  // Solo Renta.
  move_in_timeframe?: string;
  // Solo Venta.
  logistics_issue?: { had_issue: boolean; details?: string };
}

export const createVisitFeedbackEndpoint = (
  visitId: string,
  token: string,
  body: RentVisitFeedbackBody,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/ts/v1/admin/proper/visits/${visitId}/feedback`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: body,
      }),
    controller,
  };
};

// El Proper lee por su ruta (sólo visitas asignadas a él); el admin, por la
// ruta que lee el feedback de cualquier visita.
export const getVisitFeedbackEndpoint = (
  visitId: string,
  token: string,
  asAdmin = false,
) => {
  const controller = loadAbort();
  const path = asAdmin
    ? `visits/${visitId}/feedback`
    : `proper/visits/${visitId}/feedback`;
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/ts/v1/admin/${path}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const createVisitPreSaleFeedbackEndpoint = (
  visitId: string,
  token: string,
  body: PreSaleVisitFeedbackBody,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/pre-sales/v1/admin/proper/visits/${visitId}/feedback`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        data: body,
      }),
    controller,
  };
};

// El admin lee por la ruta que no filtra por Proper asignado; el Proper usa la suya.
export const getVisitPreSaleFeedbackEndpoint = (
  visitId: string,
  token: string,
  asAdmin = false,
) => {
  const controller = loadAbort();
  const path = asAdmin
    ? `visits/${visitId}/feedback`
    : `proper/visits/${visitId}/feedback`;
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/${path}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getVisitClientFeedbackLinkEndpoint = (
  visitId: string,
  token: string,
  service: ClientFeedbackService = 'pre-sales',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/${service}/v1/admin/visits/${visitId}/client-feedback/link`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

// Prefijo del servicio: pre-venta usa `pre-sales`; renta/venta, `ts`.
export type ClientFeedbackService = 'pre-sales' | 'ts';

export const getVisitClientFeedbackEndpoint = (
  visitId: string,
  token: string,
  service: ClientFeedbackService = 'pre-sales',
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/${service}/v1/admin/visits/${visitId}/client-feedback`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const deleteVisitPreSaleEndpoint = (visitId: string, token: string, reason?:string, explain_reason?:string, status?: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'put',
        url: `${urlService}/pre-sales/v1/admin/proper/visits/${visitId}/cancel`,
        data: JSON.stringify({
          reason: reason ?? '',
          explain_reason: explain_reason ?? '',
          ...(status ? { status } : {}),
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

// Advisory leads (user-service) — tab propio "Agnósticas" en InternalUserDashboard.

export interface CreateAdvisoryLeadPayload {
  first_name: string;
  last_name: string;
  phone: string;
  area_code: string;
  email: string;
  goal: string;
  property_type: string;
  delivery_time: string;
  zone: string;
  polygon_id?: number;
  polygon_level?: number;
  monthly_budget: string;
  contact_schedule: string;
  // A diferencia del lead público, el alta manual desde el admin pide estos
  // 3 de una vez y nace ya aprobada y agendada (ver
  // AdvisoryService.createApprovedLead en user-service) — no pending_approval.
  assigned_proper_id: string;
  assigned_sdr_id: string;
  scheduled_at: string;
}

// Alta manual — mismo endpoint/flujo que un lead de guest (crea o reusa un
// profile no verificado a partir del contacto), para cuando el lead entra
// por otro canal (WhatsApp, llamada, etc.) y lo carga un admin a mano. Nace
// directo en SCHEDULED, no pending_approval.
export const createAdvisoryLeadEndpoint = (
  data: CreateAdvisoryLeadPayload,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/user/v1/admin/advisory-leads`,
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getAdvisoryLeadsEndpoint = (
  queryParams: string = '',
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/admin/advisory-leads${queryParams}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const approveAdvisoryLeadEndpoint = (
  leadId: string,
  data: { assigned_proper_id: string; scheduled_at: string },
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/user/v1/admin/advisory-leads/${leadId}/approve`,
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const rescheduleAdvisoryLeadEndpoint = (
  leadId: string,
  data: { assigned_proper_id: string; scheduled_at: string },
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/user/v1/admin/advisory-leads/${leadId}/reschedule`,
        data: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

// reject y cancel son la misma acción (fusionadas) — sin endpoint de reject.

export const getAdvisoryLeadEndpoint = (leadId: string, token: string) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/user/v1/admin/advisory-leads/${leadId}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const cancelAdvisoryLeadEndpoint = (
  leadId: string,
  cancellation_reason: string,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/user/v1/admin/advisory-leads/${leadId}/cancel`,
        data: JSON.stringify({ cancellation_reason }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

// Marca que la asesoría ya se dio (sólo alcanzable desde scheduled/rescheduled,
// ver AdminAdvisoryService.finish en user-service) — notas opcionales.
export const finishAdvisoryLeadEndpoint = (
  leadId: string,
  notes: string | undefined,
  token: string,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'post',
        url: `${urlService}/user/v1/admin/advisory-leads/${leadId}/finish`,
        data: JSON.stringify(notes ? { notes } : {}),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }),
    controller,
  };
};

export const getMonthlyPreSaleReportEndpoint = (
  month: string,
  developerId: string,
  token: string,
  // `refresh=true` vuelve a generar los textos con IA (cuesta y tarda).
  refresh = false,
) => {
  const controller = loadAbort();
  return {
    call: (urlService: string) =>
      axios({
        method: 'get',
        url: `${urlService}/pre-sales/v1/admin/reports/monthly?month=${month}&developer_id=${developerId}${refresh ? '&refresh=true' : ''}`,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        // La primera consulta de un mes genera textos con IA (hasta ~60 s).
        timeout: 90000,
      }),
    controller,
  };
};
